export default {
      id: "globe-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#globe",
      toString: function () {
        return this.url;
      }
    }